/**************  CSS  **************/
import './TrainLengthCalc.css'

/**********  React hooks  **********/
import { useState, useEffect, useRef } from 'react'

/**********  Components  ***********/
import ProgressBar from '../../../Assets/ProgressBar/ProgressBar'

/************  Others  *************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function TrainLengthCalc({length, speed, backToForm, lengthOk}) {
    /***********************************/
    /* Hooks                           */
    /***********************************/
    /*************  Refs  **************/
    const totalTime = useRef((length + length * 0.1) / speed * 3600)
    const initialTime = useRef(Date.now().valueOf())
    
    /************  States  *************/
    const [currentTime, setCurrentTime] = useState(0)
    const [remainingLength, setRemainingLength] = useState(length)
    
    /************  Memos  **************/
    
    
    /***********  Callbacks  ***********/
    
    
    /************  Effects  ************/
    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now().valueOf();
            setCurrentTime(now - initialTime.current)
            if(now - initialTime.current >= totalTime.current) {
                lengthOk()
            }
        }, 5)
        return () => {
            clearInterval(interval)
        }
    }, [lengthOk])

    useEffect(() => {
        const cLength = (length / totalTime.current * currentTime).toFixed(0)
        const rLength = Math.ceil((length - cLength) / 10) * 10
        setRemainingLength(rLength)
    }, [currentTime, length])

    const buttonBackToForm = e => {
        e.preventDefault()
        backToForm()
    }

    return <div className='tda-formStyle'>
        <p>{length}m / {speed} km/h</p>
        <div className='tda-remainingLength'>
            <ProgressBar actual={currentTime} total={totalTime.current} />
            <p>{remainingLength}m</p>
        </div>
        <button onClick={buttonBackToForm}><FontAwesomeIcon icon="fa-solid fa-xmark" /></button>
    </div>
}